import { render, staticRenderFns } from "./TemplateItemsModal.vue?vue&type=template&id=2d5833c6&scoped=true"
import script from "./TemplateItemsModal.vue?vue&type=script&lang=js"
export * from "./TemplateItemsModal.vue?vue&type=script&lang=js"
import style0 from "./TemplateItemsModal.vue?vue&type=style&index=0&id=2d5833c6&scoped=true&lang=css"
import style1 from "./TemplateItemsModal.vue?vue&type=style&index=1&id=2d5833c6&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5833c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d5833c6')) {
      api.createRecord('2d5833c6', component.options)
    } else {
      api.reload('2d5833c6', component.options)
    }
    module.hot.accept("./TemplateItemsModal.vue?vue&type=template&id=2d5833c6&scoped=true", function () {
      api.rerender('2d5833c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/components/TemplateItemsModal.vue"
export default component.exports